import { render, staticRenderFns } from "./managers.vue?vue&type=template&id=59d80f8f&scoped=true&"
import script from "./managers.vue?vue&type=script&lang=js&"
export * from "./managers.vue?vue&type=script&lang=js&"
import style0 from "./managers.vue?vue&type=style&index=0&id=59d80f8f&lang=scss&scoped=true&"
import style1 from "./managers.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d80f8f",
  null
  
)

export default component.exports